export var CSS_VAR_ICON = '--icon-color';
export var CSS_VAR_TILE = '--tile-color';
export var CSS_VAR_THEMED_ICON = '--themed-icon-color';
export var CSS_VAR_THEMED_TEXT = '--themed-text-color';